import React, { useEffect, useState } from 'react';
import { fetchUserData } from '../../database/fetch-user-data';
import { Bars3Icon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { Avatar, Dropdown, Navbar } from 'flowbite-react';
import { handleLogout } from '../../auth/auth';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, getAuth } from 'firebase/auth';
import { app } from '../../resources/gcp-config';
const auth = getAuth(app);

const NavbarElement = (props) => {
  let navigate = useNavigate();

  const [userData, setUserData] = useState(null);

  /* The `useEffect` hook in this code is used to fetch user data from the database and update the
`userData` state variable. */
  // useEffect(() => {
  //   fetchUserData()
  //     .then((data) => {
  //       setUserData(data);
  //       console.log(data);
  //       localStorage.setItem('name', data.name.split(' ')[0]);
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching user data: ', error);
  //     });
  // }, []);

  // useEffect(() => {
  //   onAuthStateChanged(auth, (user) => {
  //     if (user) {
  //       console.log(user); // Log user details
  //       localStorage.setItem('email', user.email);
  //     }
  //   });
  // }, []);

  return (
    <nav
      className={classNames({
        'bg-white text-zinc-500': true, // colors
        'flex': true, // layout
        'w-screen md:w-full sticky z-10 px-4 shadow-sm top-0 ': true, //positioning & styling
      })}
    >
      <button className="md:hidden ml-4" onClick={props.onMenuButtonClick}>
        <Bars3Icon className="h-6 w-6" />
      </button>
    </nav>
  );
};

export default NavbarElement;
